const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "2026-07-12" -> "12 Jul 2026"
export const formatDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  return `${Number(d)} ${MONTHS[Number(m) - 1]} ${y}`;
};

// "12 – 19 Jul 2026" when the range sits inside one month/year
export const formatRange = (start, end) => {
  if (!start) return "";
  if (!end || end === start) return formatDate(start);
  const [sy, sm, sd] = start.split("-");
  const [ey, em, ed] = end.split("-");
  if (sy === ey && sm === em) return `${Number(sd)} – ${Number(ed)} ${MONTHS[Number(sm) - 1]} ${sy}`;
  if (sy === ey) return `${Number(sd)} ${MONTHS[Number(sm) - 1]} – ${Number(ed)} ${MONTHS[Number(em) - 1]} ${sy}`;
  return `${formatDate(start)} – ${formatDate(end)}`;
};

export const isPastRange = (end) => {
  if (!end) return false;
  const today = new Date().toISOString().slice(0, 10);
  return end < today;
};

// Two closed date ranges overlap
export const rangesClash = (aStart, aEnd, bStart, bEnd) => {
  if (!aStart || !bStart) return false;
  const a2 = aEnd || aStart;
  const b2 = bEnd || bStart;
  return aStart <= b2 && bStart <= a2;
};
